var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ 'nav-open': _vm.$sidebar.showSidebar }, { rtl: _vm.$route.meta.rtlActive }]},[_c('notifications'),_c('side-bar',{staticClass:"frontend-sidebar",attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('hotel-selection'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'dashboard',
          path: '/dashboard',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Pricing',
          icon: 'euro',
          path: '/pricing',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Calendar & Events',
          icon: 'event',
          path: '/events',
        }}}),_c('li',{},[_c('a',{staticClass:"nav-link",attrs:{"href":_vm.reporting,"target":"_blank"},on:{"click":_vm.reportingClick}},[_c('i',{staticClass:"md-icon md-icon-font md-theme-default"},[_vm._v("dynamic_feed")]),_c('p',[_vm._v("Reporting")])])]),_c('li',{staticClass:"bottom"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Pricing Strategies',
            icon: '',
            path: '/pricing-strategies',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Pricing rules',
            icon: '',
            path: '/pricing-rules',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Allotment rules',
            icon: '',
            path: '/allotment-rules',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Pax grid',
            icon: '',
            path: '/pax-grid',
          }}}),(_vm.checkRoleGroupAccess())?_c('sidebar-item',{attrs:{"link":{
            name: 'Groups List',
            icon: '',
            path: '/groups-list',
          }}}):_vm._e()],1)],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[(this.$root.hotelId)?_c('zoom-center-transition',{attrs:{"duration":300,"mode":"out-in"}},[_c('router-view')],1):_vm._e()],1),(false && !_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }